import React from 'react';

function SettingsItem({ iconName, isActive, handleClick, settingsText }) {
  return (
    <button className='cpt-bottom-icon-btn' onClick={handleClick}>
      <i className={`cpt-tamp-icon icon-${iconName} ${isActive ? 'active' : ''}`} />
      <span className='cpt-top-min-hov'>
        <span className='cpt-top-min-hov-txt'>{settingsText}</span>
      </span>
    </button>
  );
}
export default SettingsItem;
